import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql`
  mutation createFarm($name: String!, $coords: [Float!]!) {
    createFarm(name: $name, coords: $coords) {
      id
    }
  }
`;

interface FarmParams {
  name: string | null;
  coords: [number, number] | null;
}

interface Props {
  params: FarmParams;
  onCompleted: (data: Farm | undefined) => void;
  children: (
    execute: () => void,
    loading: boolean,
    createdFarm: Farm | undefined
  ) => React.ReactNode;
}

const handleCompleted = (props: Props, data: any) => {
  console.warn(data);
  props.onCompleted(data.createFarm as Farm);
};

const NewFarmProvider: React.StatelessComponent<Props> = (props: Props) => {
  return (
    <AuthorizedMutation
      mutation={GQL}
      onCompleted={data => handleCompleted(props, data)}
    >
      {(mutateFn, result) =>
        props.children(
          () => mutateFn({ variables: props.params }),
          result.loading,
          result.data
        )
      }
    </AuthorizedMutation>
  );
};

export default NewFarmProvider;



// WEBPACK FOOTER //
// ./src/providers/NewFarmProvider.tsx